import { render, staticRenderFns } from "./ConfigModule.vue?vue&type=template&id=4c1dd167&"
import script from "./ConfigModule.vue?vue&type=script&lang=js&"
export * from "./ConfigModule.vue?vue&type=script&lang=js&"
import style0 from "./ConfigModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports